module.exports = __webpack_public_path__ + "static/img/ground4.18c1bee1.png";